export default "__VITE_ASSET__BHl1Dvob__"